import React from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import Flex from '../Flex';

import PropTypes from 'prop-types';
import Pagination from './Pagination';
import PaginationInfo from './PaginationInfo';

const FullPagination = ({ itemsPerPage = [5, 10, 15, 20, 50, 100], perPage, meta, preText = 'Mostrando', posText = '', className, nextPage, prevPage, goToPage }) => {

    const classNames = [className].join(' ')

    return  <>
                <Card className={classNames}>
                    <CardBody>
                        <Row className="justify-content-between align-items-center">
                            <Col sm="auto" className="mb-2 mb-sm-0" tag={Flex} align="center">
                                <Pagination
                                    meta={meta}
                                    nextPage={nextPage}
                                    prevPage={prevPage}
                                    goToPage={goToPage}
                                />
                            </Col>

                            <Col sm="auto" className="mb-2 mb-sm-0" tag={Flex} align="center">
                                <PaginationInfo
                                    itemsPerPage={itemsPerPage}
                                    meta={meta}
                                    perPage={perPage}
                                    preText={preText}
                                    posText={posText} />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </>
}

FullPagination.propTypes = {
    itemsPerPage: PropTypes.array,
    meta: PropTypes.object.isRequired,
    preText: PropTypes.string,
    posText: PropTypes.string,
    className: PropTypes.string,
    perPage: PropTypes.func.isRequired,
    nextPage: PropTypes.func.isRequired,
    prevPage: PropTypes.func.isRequired,
    goToPage: PropTypes.func.isRequired
}
export default FullPagination;